(() => {
  if (window.foodySeasonPageLoaded) return;
  window.foodySeasonPageLoaded = true;
  const cleanups = new WeakMap();
  function init(scope = document) {
    scope.querySelectorAll('[data-foody-season-page]').forEach(root => {
      if (cleanups.has(root)) return;
      const controller = new AbortController();
      const opts = { signal: controller.signal };
      const slider = root.querySelector('.explore-swiper');
      const config = JSON.parse(root.querySelector('[data-season-config]')?.textContent || '{}');
      const count = slider?.querySelectorAll('.swiper-slide').length || 0;
      const max = Math.max(config.slidesPerView, ...Object.values(config.breakpoints || {}).map(b => b.slidesPerView));
      config.loop = config.loop && count >= max + 1;
      const swiper = count && typeof window.Swiper === 'function' ? new window.Swiper(slider, { ...config, speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450, rewind: !config.loop, navigation: { nextEl: root.querySelector('.explore-next') }, keyboard: { enabled: true, onlyInViewport: true }, a11y: { enabled: true }, watchOverflow: true }) : null;
      const quiz = root.querySelector('[data-season-quiz]');
      const steps = [...(quiz?.querySelectorAll('[data-season-step]') || [])];
      const result = quiz?.querySelector('[data-season-result-content]');
      let mood = 0;
      function step(index) {
        steps.forEach((el, i) => { el.hidden = i !== index; });
        result.hidden = true;
        if (index === 1) steps[1].querySelector('h3').focus();
      }
      root.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-season-quiz-open')) { mood = 0; step(0); quiz.showModal(); }
        if (button.hasAttribute('data-season-close')) button.closest('dialog').close();
        if (button.hasAttribute('data-season-reviews')) root.querySelector('[data-season-review-dialog]').showModal();
        if (button.hasAttribute('data-season-restart')) { step(0); steps[0].querySelector('button')?.focus(); }
        if (button.hasAttribute('data-season-mood')) { mood = Number(button.dataset.seasonMood); step(1); }
        if (button.hasAttribute('data-season-result')) {
          const index = mood === 2 ? button.dataset.sunny : mood === 3 ? button.dataset.social : button.dataset.seasonResult;
          const template = quiz.querySelector(`[data-season-result-template="${index}"]`) || quiz.querySelector('template');
          if (!template) { step(0); return; }
          result.replaceChildren(template.content.cloneNode(true));
          steps.forEach(el => { el.hidden = true; });
          result.hidden = false;
          result.focus();
        }
      }, opts);
      root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, opts));
      const form = root.querySelector('form.season-kit');
      let busy = false;
      if (form) {
        const button = form.querySelector('[data-season-add]');
        const select = form.querySelector('[data-season-variant]');
        const status = form.querySelector('[data-season-status]');
        function update() {
          if (!select) return;
          const selected = select.selectedOptions[0];
          button.disabled = busy || selected.dataset.available !== 'true';
          window.FoodyText.set(button, selected.dataset.available === 'true' ? `${button.dataset.add} — ${selected.dataset.price}` : button.dataset.sold);
          window.FoodyText.set(root.querySelector('[data-season-price]'), selected.dataset.price);
          form.elements.quantity.value = selected.dataset.min || '1';
        }
        select?.addEventListener('change', update, opts);
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (busy || button.disabled) return;
          const body = new FormData(form);
          busy = true; button.disabled = true; window.FoodyText.set(status, '');
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body, signal: controller.signal });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || root.dataset.error);
            window.FoodyText.set(status, root.dataset.added);
            document.dispatchEvent(new CustomEvent('foody:cart-added'));
          } catch (error) { if (error.name !== 'AbortError') window.FoodyText.set(status, error.message || root.dataset.error); }
          finally { busy = false; if (!controller.signal.aborted) { button.disabled = false; update(); } }
        }, opts);
      }
      cleanups.set(root, () => { controller.abort(); swiper?.destroy(true, true); root.querySelectorAll('dialog[open]').forEach(d => d.close()); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-foody-season-page]').forEach(root => { cleanups.get(root)?.(); cleanups.delete(root); }));
})();
